import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nPipe } from '@delon/theme';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { finalize } from 'rxjs';
import { HttpService } from 'src/app/http/http.service';
import { CanComponentDeactivate } from 'src/app/providers/can-deactivate.guard';
import { GlobalGuardService } from 'src/app/providers/global-guard.service';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { ConstantUtil } from 'src/app/util/constant.util';

import { ServiceConfigComponent } from '../../servicenumber/detail/config/servicenumber-config.component';

@Component({
  selector: 'personal-service-setting',
  standalone: true,
  imports: [CommonModule, NzSpinModule, NzCardModule, I18nPipe, ServiceConfigComponent, TestIdDirective],
  templateUrl: './personal-service-setting.component.html',
  styleUrls: ['./personal-service-setting.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalServiceSettingComponent implements OnInit, OnDestroy, CanComponentDeactivate {
  private readonly route = inject(ActivatedRoute);
  private readonly http = inject(HttpService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly globalGuardService = inject(GlobalGuardService);
  @ViewChild(ServiceConfigComponent) private serviceConfigComponent?: ServiceConfigComponent;

  loading = false;
  tenantId: string = '';

  serviceNumberId: string = '';
  serviceNumberType: string = '';
  tenantType: string = '';
  hasUnsavedChanges = false;

  ngOnInit(): void {
    this.globalGuardService.registerComponent(this);
    this.route.paramMap.subscribe(params => {
      this.tenantId = params.get('id') ?? '';
      this.serviceNumberId = localStorage.getItem('current_tenant_boss_snid') ?? '';
      if (this.serviceNumberId) {
        this.fetchServiceNumberMeta(this.serviceNumberId);
      }
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.globalGuardService.unregisterComponent();
  }

  onUnsavedChangesChange(hasChanged: boolean): void {
    this.hasUnsavedChanges = hasChanged;
    this.cdr.detectChanges();
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges) {
      $event.returnValue = true;
    }
  }

  canDeactivate(): boolean | Promise<boolean> {
    return this.serviceConfigComponent?.canDeactivate() ?? true;
  }

  private fetchServiceNumberMeta(id: string): void {
    this.loading = true;
    this.http
      .post(`${ConstantUtil.ADMIN_SERVICENUMBER_DETAIL}/${id}`, {})
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe(res => {
        if (res?.success) {
          const data = res?.data?.serviceNumberModel ?? res?.data ?? {};
          const tenantModel = res?.data?.tenantModel ?? {};
          this.serviceNumberType = data?.type ?? '';
          this.tenantType = tenantModel?.type ?? '';
        }
      });
  }
}
